import { render, staticRenderFns } from "./promote-adverts-list-item.vue?vue&type=template&id=3eb80d02"
import script from "./promote-adverts-list-item.vue?vue&type=script&lang=ts"
export * from "./promote-adverts-list-item.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports